(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_5edf978"] && !Shopify.designMode) return;
  try {
    (() => {
    const escapeVCard = (value) => String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/\r\n|\r|\n/g, '\\n')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,');
    const foldLine = (line) => {
      const encoder = new TextEncoder();
      const parts = [];
      let part = '';
      let bytes = 0;
      for (const character of line) {
        const length = encoder.encode(character).length;
        if (bytes + length > 75) {
          parts.push(part);
          part = ' ';
          bytes = 1;
        }
        part += character;
        bytes += length;
      }
      parts.push(part);
      return parts.join('\r\n');
    };
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-linktree-save-contact]');
      if (!button) return;
      const data = button.dataset;
      const name = (data.vcfName || '').trim();
      const phone = (data.vcfPhone || '').replace(/^tel:/i, '').split(/[;?]/)[0].replace(/[^+0-9]/g, '');
      let email = (data.vcfEmail || '').replace(/^mailto:/i, '').split('?')[0].trim();
      try { email = decodeURIComponent(email); } catch {}
      const website = (data.vcfWebsite || '').trim();
      const lines = ['BEGIN:VCARD', 'VERSION:3.0', 'FN:' + escapeVCard(name), 'N:;' + escapeVCard(name) + ';;;'];
      if (data.vcfCompany) lines.push('ORG:' + escapeVCard(data.vcfCompany));
      if (data.vcfTitle) lines.push('TITLE:' + escapeVCard(data.vcfTitle));
      if (phone) lines.push('TEL;TYPE=CELL,VOICE:' + phone);
      if (email) lines.push('EMAIL;TYPE=INTERNET,WORK:' + escapeVCard(email));
      if (/^https?:\/\//i.test(website)) lines.push('URL:' + website.replace(/[\r\n]/g, ''));
      const notes = ['Profile: ' + window.location.href.split(/[?#]/)[0]];
      const root = button.closest('[data-linktree-contact-page]');
      const seen = new Set();
      if (root) root.querySelectorAll('a[href]').forEach((link) => {
        const url = link.href;
        if (!/^(https?:|weixin:)/i.test(url) || url === website || seen.has(url)) return;
        seen.add(url);
        const label = (link.textContent.trim() || link.getAttribute('aria-label') || 'Link').replace(/\s+/g, ' ');
        notes.push(label + ': ' + url);
      });
      lines.push('NOTE:' + escapeVCard(notes.join('\n')), 'END:VCARD');
      const card = lines.map(foldLine).join('\r\n') + '\r\n';
      const blob = new Blob([card], { type: 'text/vcard;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = (name.replace(/[^\p{L}\p{N}_-]+/gu, '_') || 'contact') + '.vcf';
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
